<h2 [style.color]="color" [ngClass]="{ 'padding-mobile': paddingMobile }">
  <ng-content></ng-content>
</h2>
